import axios from "axios";
const origin = window.location.origin;
export default axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-type": "application/json",
    "X-Tenant": origin,
  },
});
